import { setIsToastOpen } from "./slices/errorModal";
export var routeAndCloseBannerMiddleware = function routeAndCloseBannerMiddleware(_ref) {
  var dispatch = _ref.dispatch;
  return function (next) {
    return function (action) {
      if (action.type === 'router/changeRoute') {
        dispatch(setIsToastOpen({
          isOpen: false
        }));
      }
      return next(action);
    };
  };
};

/* istanbul ignore next */
export var printRouteMiddleware = function printRouteMiddleware() {
  return function (next) {
    return function (action) {
      try {
        if (window.location.search.indexOf('MFA_BY_APP') == -1) {
          next(action);
          return;
        }
      } catch (e) {
        next(action);
        return;
      }
      console.info("MfaDialog Action", action);
      next(action);
    };
  };
};